// extracted by mini-css-extract-plugin
export default {"option":"TopicPermissionInfo-module__option--z9AbX","icon":"TopicPermissionInfo-module__icon--vbLYB","animatedBackground":"TopicPermissionInfo-module__animatedBackground--Yz-kh"};